import FundPage from "../components/FundPage";

const Fund = () => {
  return (
      <FundPage />
  );
}

export default Fund;